import { FileQuestion } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { hasValue } from "@core/foundation/types";

import { Button } from "@react/ui-primitives/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@react/ui-primitives/empty";

export const NotFoundView: FC<{
  readonly actionLabel?: string;
  readonly description?: string;
  readonly onAction?: () => void;
  readonly title?: string;
}> = ({
  actionLabel,
  description = "The page you're looking for doesn't exist or has been moved.",
  onAction,
  title = "Page not found",
}) => (
  <div className="flex size-full flex-1 items-center justify-center">
    <Empty className="border-none">
      <EmptyMedia variant="icon">
        <FileQuestion className="text-muted-foreground" />
      </EmptyMedia>
      <EmptyHeader>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      {hasValue(actionLabel) && (
        <EmptyContent>
          <Button onClick={onAction} variant="outline">
            {actionLabel}
          </Button>
        </EmptyContent>
      )}
    </Empty>
  </div>
);
